import { SET_IS_LOADING, SET_TOKEN, SET_ERRORS, CLEAR_ERRORS } from './constants';

const initialState = {
  isLoading: false,
  name: '',
  expirationDays: '',
  allowedDomains: [],
  establishmentIds: [],
  restrictions: [],
  errors: {
    expirationDays: null
  }
}

const openApiRegistrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action.payload
      }
    }
    case SET_TOKEN: {
      const { name, expirationDays, allowedDomains, establishmentsId, restrictions } = action?.payload || {};

      return {
        ...state,
        name,
        expirationDays,
        allowedDomains,
        establishmentIds: establishmentsId,
        restrictions
      }
    }
    case SET_ERRORS: {
      return {
        ...state,
        errors: {
          expirationDays: action.errors?.expirationDays ? action.errors?.expirationDays[0] : null
        }
      }
    }
    case CLEAR_ERRORS: {
      return {
        ...state,
        errors: initialState.errors
      }
    }
    default: {
      return state;
    }
  }
}

export default openApiRegistrationReducer;